import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, version: String }

  connect() {
    if (!this.urlValue) return

    this.check = this.check.bind(this)
    this.timer = window.setInterval(this.check, 15000)
    window.addEventListener("focus", this.check)
    document.addEventListener("visibilitychange", this.check)
  }

  disconnect() {
    window.clearInterval(this.timer)
    window.removeEventListener("focus", this.check)
    document.removeEventListener("visibilitychange", this.check)
  }

  async check() {
    if (document.hidden || this.checking || this.reloading) return

    this.checking = true
    try {
      const response = await fetch(this.urlValue, {
        cache: "no-store",
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
      if (!response.ok || !response.headers.get("content-type")?.includes("application/json")) return

      const { version } = await response.json()
      if (String(version) !== this.versionValue) {
        this.reloading = true
        window.location.reload()
      }
    } catch {
      // A próxima checagem tentará novamente após uma falha de conexão.
    } finally {
      this.checking = false
    }
  }
}
